/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.call(this, ...args), wait);
    };
};
//# sourceMappingURL=debounce.js.map
